export default {
  domain: 'oleads.auth0.com',
  clientId: 'M9fyyzbMY4B22y2sQit6ae453NKKO0Ys',
  audience: 'https://api.oleads.ai',
};
